// ============================================================================
// OBT — Erişim kapısı (istemci tarafı ikinci katman)
// ============================================================================
// Bu bileşen GERÇEK yetkilendirme değildir. Asıl yetki backend'dedir:
// JWT + `personnel` tablosundan okunan rol + ChainService kapsamı. Buradaki
// kontrol yalnız kullanıcı deneyimi ve yanlışlıkla açılan ekranları önlemek
// içindir.
//
// Rol bilgisi YALNIZ doğrulanmış auth/authorization kaynağından okunur.
// URL, query parametresi veya localStorage üzerinden rol/scope üretilmez.
//
// Auth yüklenirken hiçbir zaman "yetkiniz yok" gösterilmez (yanlış negatif
// parlaması) ve hiçbir zaman içerik gösterilmez (yanlış pozitif sızıntısı);
// yalnız yükleniyor durumu gösterilir.
// ============================================================================

import { useAuth } from '@/auth/AuthContext';
import { useAuthorization } from '@/auth/AuthorizationContext';
import { canAccessObt, obtDashboardKindForRole } from './obtRoles';
import { ObtLoading, ObtUnauthorized } from './ObtStates';

/**
 * OBT erişim durumunu döndürür.
 * @returns {{ready: boolean, isLoggedIn: boolean, role: string, allowed: boolean, dashboardKind: string|null}}
 */
export function useObtAccess() {
  const { bootstrapping, isLoggedIn } = useAuth();
  const { role, userRole, loading: authzLoading } = useAuthorization();

  const effectiveRole = role || userRole || '';
  // Rol henüz belli değilken karar verilmez.
  const ready = !bootstrapping && (!authzLoading || Boolean(effectiveRole));

  return {
    ready,
    isLoggedIn: Boolean(isLoggedIn),
    role: effectiveRole,
    allowed: ready && Boolean(isLoggedIn) && canAccessObt(effectiveRole),
    dashboardKind: obtDashboardKindForRole(effectiveRole),
  };
}

export default function ObtAccessGuard({ children }) {
  const { ready, isLoggedIn, allowed } = useObtAccess();

  if (!ready) {
    return <ObtLoading label="Yetki bilgisi kontrol ediliyor…" />;
  }

  if (!isLoggedIn) {
    return (
      <ObtUnauthorized message="Bu bölümü görüntülemek için giriş yapmanız gerekiyor." />
    );
  }

  if (!allowed) {
    return (
      <ObtUnauthorized message="Operasyonel Bilgi Toplama bölümü yalnızca Müdür, Müdür Yardımcısı, Bölge Mühendisi ve Formen rolleri içindir." />
    );
  }

  return children;
}
